import { combineReducers } from 'redux'
import { combineEpics } from 'redux-observable'
import { galleryEpic } from './gallery/gallery-epics'
import { navigationActions, navigationEpic, navigationReducer, NavigationState } from './navigation'
import { userReducer, UserState } from './user/user-reducer'
import { historyReducer, HistoryState } from './history/history-reducer'
import { eventActions, eventsEpic } from './events'
import { notificationActions, notificationEpic, notificationReducer, NotificationState } from './notification'
import { userActions } from './user/user-actions'
import { userEpic } from './user/user-epics'
import { galleryActions } from './gallery/gallery-actions'
import { galleryReducer, GalleryState } from './gallery/gallery-reducer'
import { historyActions } from './history/history-actions'
import { historyEpic } from './history/history-epics'
import { systemActions, systemEpic, systemReducer, SystemState } from './system'
import { filesActions, filesEpic } from './files'

export const globalActions = {
    eventActions,
    galleryActions,
    historyActions,
    navigationActions,
    notificationActions,
    userActions,
    systemActions,
    filesActions,
}

export interface GlobalState {
    gallery: GalleryState,
    history: HistoryState,
    navigation: NavigationState,
    notification: NotificationState,
    user: UserState,
    system: SystemState,
}

export const globalReducer = combineReducers<GlobalState>({
    gallery: galleryReducer,
    history: historyReducer,
    navigation: navigationReducer,
    user: userReducer,
    notification: notificationReducer,
    system: systemReducer,
})

export const globalEpic = combineEpics(
    galleryEpic, eventsEpic, historyEpic, navigationEpic, notificationEpic, userEpic, systemEpic, filesEpic,
)